"use client";

import styled from "styled-components";
import Image from "../image";

interface BoxRanking {
  $colorIcon: "red" | "green" | "blue" | "purple" | "yellow" | undefined;
}

export const List = styled.ul`
  padding: 0;
  margin: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 768px) {
    gap: 0.75rem;
  }
`;

export const FirstBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  flex: 1;
  min-width: 0;

  @media (min-width: 768px) {
    gap: 0.875rem;
  }
`;

export const BoxRank = styled.span`
  font-family: "Inter Semibold";
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  background: var(--whiteGray);
  color: var(--textLight);
  flex-shrink: 0;
  transition: all 0.2s ease;

  @media (min-width: 768px) {
    font-size: 13px;
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 12px;
  }
`;

export const ImageComponent = styled(Image)`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;

  @media (min-width: 768px) {
    border-radius: 12px;
  }
`;

export const BoxInfoList = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1;
  min-width: 0;

  @media (min-width: 768px) {
    gap: 0.25rem;
  }
`;

export const UserName = styled.span`
  font-family: "Inter Semibold";
  font-size: 13px;
  color: var(--colorTitle);
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 140px;

  @media (min-width: 768px) {
    font-size: 15px;
    line-height: 1.4;
    max-width: 100%;
  }
`;

export const DescriptionUser = styled.span`
  font-family: "Inter Regular";
  font-size: 11px;
  color: var(--textLight);
  line-height: 1.3;
  text-transform: capitalize;

  @media (min-width: 768px) {
    font-size: 12px;
    line-height: 1.4;
  }
`;

export const LastBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
`;

export const LastContent = styled.span`
  font-family: "Inter Semibold";
  font-size: 13px;
  color: var(--colorTitle);
  line-height: 1.3;
  white-space: nowrap;

  @media (min-width: 768px) {
    font-size: 15px;
    line-height: 1.4;
  }
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.625rem;
  border-radius: 10px;
  background: transparent;
  transition: all 0.2s ease;
  cursor: default;
  border: 1px solid transparent;

  @media (min-width: 768px) {
    gap: 1rem;
    padding: 0.875rem;
    border-radius: 12px;
  }

  &:hover {
    background: var(--grayCard);
    border-color: var(--borderColor);
    transform: translateX(2px);
  }

  &:first-child {
    ${BoxRank} {
      background: linear-gradient(
        135deg,
        var(--primarySystem100),
        var(--primarySystem200)
      );
      color: white;
      box-shadow: 0 2px 8px rgba(0, 85, 255, 0.2);
    }
  }

  &:nth-child(2) {
    ${BoxRank} {
      background: linear-gradient(
        135deg,
        var(--primarySystem200),
        var(--primarySystem300)
      );
      color: white;
      box-shadow: 0 2px 6px rgba(0, 85, 255, 0.15);
    }
  }

  &:nth-child(3) {
    ${BoxRank} {
      background: linear-gradient(
        135deg,
        var(--primarySystem300),
        var(--primarySystem400)
      );
      color: white;
      box-shadow: 0 2px 6px rgba(0, 85, 255, 0.15);
    }
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
